
















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import User from '@/models/User';
import UserService from '@/services/UserService';

@Component
export default class UserEdit extends Vue {
    @Prop() public id!: number;
    @Prop() public isAdmin!: boolean;
    @Prop() public customerid!: number;

    private Model: User ;
    private PageTitle: string = '';
    private Validated: boolean = false;

    constructor() {
        super();
        this.Model = new User();
    }

    private async created() {
        this.PageTitle = `${this.id === 0 ? 'New' : 'Edit'} User`;
        this.Model.CustomerId = this.customerid;
        this.Model.IsAdmin = this.isAdmin !== undefined ? this.isAdmin : false;

        if (this.id > 0) {
            this.LoadUser(this.id);
        } else {
            this.Model.Id = this.id;
        }
    }

    private async LoadUser(id: number) {
        const customerService = new UserService();
        const response = await customerService.LoadUser(id);
        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to load the information`);
        } else {
            if (response.Data != null) {
                this.Model = response.Data;
            }
        }
    }

    private async SaveForm() {
        const userService = new UserService();

        let response: any;
        if (this.id === 0) {
            response = await userService.AddUser(this.Model);
        } else {
            response = await userService.UpdateUser(this.Model);
        }

        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to save the information`);
        } else {
            this.$emit('changessaved', this.id > 0);
            this.$emit('editcancelled');
        }
    }

    private CancelSave() {
        this.$emit('editcancelled');
    }

    private PropertyState(propertyName: string) {
        if (!this.Validated) {
            return null;
        } else {
            const statusObj = this.Model.PropertyState(propertyName);
            if (statusObj) {
                return statusObj.Status;
            } else {
                return null;
            }
        }
    }

    private PropertyMessage(propertyName: string) {
        if (!this.Validated) {
            return '';
        } else {
            const statusObj = this.Model.PropertyState(propertyName);
            if (statusObj) {
                return statusObj.Message;
            } else {
                return null;
            }
        }
    }
}
